import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const fingerprinter: Example = {
  id: "fingerprinter",
  title: "Browser fingerprinting",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Hashes navigator, screen, Intl, and canvas traits into an ID",
  explainer:
    "Every identifying read is a FPRINT event: user agent, languages, cores, memory, plugins, screen, time zone, a media query, and the canvas read-back. Change the device in the Context drawer and the reported ID changes with it.",
  code,
  expect: golden as Example["expect"],
};
